import SubscriberDetailPage from "./pages/SubscriberDetailPage";
import SubscriberListPage from "./pages/SubscriberListPage";
import SubscriberAddTrialPage from "./pages/SubscriberAddTrialPage";
import SubscriberBookServicePage from "./pages/SubscriberBookServicePage";
import SubscriberReportPage from "./pages/SubscriberReportPage";
import SubscriberAddOfflinePurchase from "./pages/SubscriberAddOfflinePurchase";
import SubscriberAccountingReportPage from "./pages/SubscriberAccountingReportPage"

export const subscriberRoutes = (prefix = "subscribers") => [
  {
    name: "SubscriberReportPage",
    path: `${prefix}/reports`,
    component: SubscriberReportPage
  },
  {
    name: "SubscriberAddTrialPage",
    path: `${prefix}/trial`,
    component: SubscriberAddTrialPage
  },
  {
    name: "SubscriberBookServicePage",
    path: `${prefix}/:id/book-service`,
    component: SubscriberBookServicePage
  },
  {
    name: "SubscriberAddOfflinePurchase",
    path: `${prefix}/package`,
    component: SubscriberAddOfflinePurchase
  },
  {
    name: "SubscriberDetailPage",
    path: `${prefix}/:id`,
    component: SubscriberDetailPage
  },
  {
    name: "SubscriberListPage",
    path: prefix,
    component: SubscriberListPage
  },
  {
    name: "SubscriberAccountingReportPage",
    path: `${prefix}/reports/accounting`,
    component: SubscriberAccountingReportPage
  },
];
